import React, { useState, useEffect } from 'react';
import {
    Box, Tabs, Tab, Typography, TextField, Button,
    Table, TableBody, TableCell, TableHead, TableRow,
    Paper, Select, MenuItem, FormControl, InputLabel,
    Autocomplete, Card, CardContent, CardHeader, Grid,
    Container, Divider, IconButton, TableContainer,
    Tooltip, CircularProgress, Dialog, DialogTitle,
    DialogContent, DialogActions, Chip, Stack, InputAdornment,
    Switch, FormControlLabel, Avatar, Grow
} from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PublicIcon from '@mui/icons-material/Public';
import BusinessIcon from '@mui/icons-material/Business';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import EmailIcon from '@mui/icons-material/Email';
import axios from 'axios';
import Loading from '../components/Loading';
import API_URL from '../config';
import RolePermissions from '../components/RolePermissions';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function stringToColor(string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
            width: 32,
            height: 32,
            fontSize: '0.875rem'
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1] ? name.split(' ')[1][0] : ''}`,
    };
}


function Setup() {
    const [value, setValue] = useState(0);
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [countries, setCountries] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [ticketTypes, setTicketTypes] = useState([]);
    const [emailConfigs, setEmailConfigs] = useState([]);
    const [loading, setLoading] = useState(true);

    // Form States
    const [newUser, setNewUser] = useState({ username: '', password: '', full_name: '', user_desc: '', role_id: '', role_ids: [], country_ids: [], division_ids: [], manager_id: '' });
    const [editingUserId, setEditingUserId] = useState(null);

    const [newRole, setNewRole] = useState('');
    const [newCountry, setNewCountry] = useState({ name: '', code: '' });
    const [newDivision, setNewDivision] = useState({ name: '', code: '' });
    const [newTicketType, setNewTicketType] = useState('');
    const [newTicketTypeDesc, setNewTicketTypeDesc] = useState('');
    const [editingTypeId, setEditingTypeId] = useState(null);
    const [editTypeName, setEditTypeName] = useState('');
    const [editTypeDesc, setEditTypeDesc] = useState('');
    const [openEditTypeDialog, setOpenEditTypeDialog] = useState(false);

    // Sub-type states
    const [expandedTypeId, setExpandedTypeId] = useState(null);
    const [openSubTypeDialog, setOpenSubTypeDialog] = useState(false);
    const [subTypeParentId, setSubTypeParentId] = useState(null);
    const [newSubType, setNewSubType] = useState({ description: '', responsible_user_ids: [], country_ids: [] });
    const [editingSubType, setEditingSubType] = useState(null);
    const [openEditSubTypeDialog, setOpenEditSubTypeDialog] = useState(false);

    // Refactored UI States
    const [openUserDialog, setOpenUserDialog] = useState(false);
    const [openRoleDialog, setOpenRoleDialog] = useState(false);
    const [openCountryDialog, setOpenCountryDialog] = useState(false);
    const [openDivisionDialog, setOpenDivisionDialog] = useState(false);
    const [openTicketTypeDialog, setOpenTicketTypeDialog] = useState(false);

    // Mobile App states
    const [mobileApps, setMobileApps] = useState([]);
    const [openMobileAppDialog, setOpenMobileAppDialog] = useState(false);
    const [editingMobileAppId, setEditingMobileAppId] = useState(null);
    const [newMobileApp, setNewMobileApp] = useState({ app_type: '', link: '', version: '' });

    // Email Config states
    const [openEmailConfigDialog, setOpenEmailConfigDialog] = useState(false);
    const [editingEmailConfigId, setEditingEmailConfigId] = useState(null);
    const [newEmailConfig, setNewEmailConfig] = useState({ division_id: '', country_id: '', email: '' });

    const [userSearchTerm, setUserSearchTerm] = useState('');

    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };


    // AD Search
    const [adUsers, setAdUsers] = useState([]);
    const [adLoading, setAdLoading] = useState(false);

    const handleADSearch = async (query) => {
        if (!query || query.length < 3) {
            setAdUsers([]);
            return;
        }
        setAdLoading(true);
        try {
            const res = await axios.get(`${API_URL}/tickets/search-ad-users?q=${query}`, { headers });
            setAdUsers(res.data);
        } catch (e) {
            console.error(e);
        } finally {
            setAdLoading(false);
        }
    };

    // ... existing fetch logic ...

    const fetchData = async () => {
        setLoading(true);
        const fetchEndpoint = async (url, setter) => {
            try {
                const res = await axios.get(url, { headers });
                setter(res.data);
            } catch (err) {
                console.error(`Error fetching ${url}:`, err);
                if (err.response && err.response.status === 401) {
                    // Token might be expired
                    alert("Session expired. Please logout and login again.");
                }
            }
        };

        await Promise.all([
            fetchEndpoint(`${API_URL}/setup/users`, setUsers),
            fetchEndpoint(`${API_URL}/setup/roles`, setRoles),
            fetchEndpoint(`${API_URL}/setup/countries`, setCountries),
            fetchEndpoint(`${API_URL}/setup/divisions`, setDivisions),
            fetchEndpoint(`${API_URL}/ticket-types`, setTicketTypes)
        ]);
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
        fetchMobileApps();
        fetchEmailConfigs();
    }, []);

    const handleCreateUser = async () => {
        try {
            await axios.post(`${API_URL}/setup/users`, newUser, { headers });
            fetchData();
            setNewUser({ username: '', password: '', full_name: '', user_desc: '', role_id: '', role_ids: [], country_ids: [], division_ids: [], manager_id: '' });
            setOpenUserDialog(false);
        } catch (err) {
            alert('Error creating user');
        }
    };

    const handleEditUser = (user) => {
        setEditingUserId(user.id);
        setNewUser({
            username: user.username,
            password: '', // Leave empty to not change
            full_name: user.full_name,
            user_desc: user.user_desc || '',
            role_id: user.role_id || '',
            role_ids: user.role_ids || (user.roles ? user.roles.map(r => r.id || r) : []) || [],
            country_ids: user.country_ids || [],
            division_ids: user.division_ids || [],
            manager_id: user.manager_id || ''
        });
        setOpenUserDialog(true);
    };

    const handleUpdateUser = async () => {
        try {
            await axios.put(`${API_URL}/setup/users/${editingUserId}`, newUser, { headers });
            fetchData();
            handleCancelEdit();
            setOpenUserDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error updating user');
        }
    };

    const handleDeleteUser = async (id) => {
        if (!window.confirm('Are you sure you want to delete this user?')) return;
        try {
            await axios.delete(`${API_URL}/setup/users/${id}`, { headers });
            fetchData();
        } catch (err) {
            alert(err.response?.data?.message || 'Error deleting user');
        }
    };

    const handleCancelEdit = () => {
        setEditingUserId(null);
        setNewUser({ username: '', password: '', full_name: '', user_desc: '', role_id: '', role_ids: [], country_ids: [], division_ids: [], manager_id: '' });
    };

    const handleCreateRole = async () => {
        try {
            await axios.post(`${API_URL}/setup/roles`, { name: newRole }, { headers });
            fetchData();
            setNewRole('');
            setOpenRoleDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error creating role');
        }
    };

    const handleCreateCountry = async () => {
        try {
            await axios.post(`${API_URL}/setup/countries`, newCountry, { headers });
            fetchData();
            setNewCountry({ name: '', code: '' });
            setOpenCountryDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error creating country');
        }
    };

    const handleCreateDivision = async () => {
        try {
            await axios.post(`${API_URL}/setup/divisions`, newDivision, { headers });
            fetchData();
            setNewDivision({ name: '', code: '' });
            setOpenDivisionDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error creating division');
        }
    };

    const handleCreateTicketType = async () => {
        if (!newTicketType.trim()) { alert('Name is required'); return; }
        try {
            await axios.post(`${API_URL}/ticket-types`, {
                name: newTicketType,
                description: newTicketTypeDesc
            }, { headers });
            syncTicketUsers();
            fetchData();
            setNewTicketType('');
            setNewTicketTypeDesc('');
            setOpenTicketTypeDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error creating ticket type');
        }
    };

    const handleDeleteTicketType = async (id) => {
        if (!window.confirm('Are you sure?')) return;
        try {
            await axios.delete(`${API_URL}/ticket-types/${id}`, { headers });
            syncTicketUsers();
            fetchData();
        } catch (err) {
            alert('Error deleting ticket type');
        }
    };

    const handleUpdateTicketType = async () => {
        if (!editTypeName.trim()) { alert('Name is required'); return; }
        try {
            await axios.put(`${API_URL}/ticket-types/${editingTypeId}`, {
                name: editTypeName,
                description: editTypeDesc
            }, { headers });
            syncTicketUsers();
            fetchData();
            setOpenEditTypeDialog(false);
            setEditingTypeId(null);
            setEditTypeName('');
            setEditTypeDesc('');
        } catch (err) {
            alert(err.response?.data?.message || 'Error updating ticket type');
        }
    };

    const handleOpenEditTicketType = (t) => {
        setEditingTypeId(t.id);
        setEditTypeName(t.name);
        setEditTypeDesc(t.description || '');
        setOpenEditTypeDialog(true);
    };

    const handleOpenSubTypeDialog = (typeId) => {
        setSubTypeParentId(typeId);
        setNewSubType({ description: '', responsible_user_ids: [], country_ids: [] });
        setOpenSubTypeDialog(true);
    };

    const handleCreateSubType = async () => {
        if (!newSubType.description.trim()) { alert('Description is required'); return; }
        try {
            await axios.post(`${API_URL}/ticket-types/${subTypeParentId}/sub-types`, {
                description: newSubType.description,
                responsible_user_ids: newSubType.responsible_user_ids,
                country_ids: newSubType.country_ids
            }, { headers });
            syncTicketUsers();
            fetchData();
            setOpenSubTypeDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error creating sub-type');
        }
    };

    const handleDeleteSubType = async (subId) => {
        if (!window.confirm('Delete this sub-type?')) return;
        try {
            await axios.delete(`${API_URL}/ticket-types/sub-types/${subId}`, { headers });
            syncTicketUsers();
            fetchData();
        } catch (err) {
            alert('Error deleting sub-type');
        }
    };

    const handleOpenEditSubType = (s) => {
        setEditingSubType({
            id: s.id,
            description: s.description,
            responsible_user_ids: (s.responsible_users || []).map(u => u.id),
            country_ids: (s.countries || []).map(c => c.id)
        });
        setOpenEditSubTypeDialog(true);
    };

    const fetchMobileApps = async () => {
        try {
            const res = await axios.get(`${API_URL}/setup/mobile-apps`, { headers });
            setMobileApps(res.data);
        } catch (err) { console.error(err); }
    };

    const fetchEmailConfigs = async () => {
        try {
            const res = await axios.get(`${API_URL}/setup/email-configs`, { headers });
            setEmailConfigs(res.data);
        } catch (err) { console.error(err); }
    };

    const handleCreateEmailConfig = async () => {
        try {
            await axios.post(`${API_URL}/setup/email-configs`, newEmailConfig, { headers });
            fetchEmailConfigs();
            setNewEmailConfig({ division_id: '', country_id: '', email: '' });
            setOpenEmailConfigDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error creating email config');
        }
    };

    const handleUpdateEmailConfig = async () => {
        try {
            await axios.put(`${API_URL}/setup/email-configs/${editingEmailConfigId}`, newEmailConfig, { headers });
            fetchEmailConfigs();
            setNewEmailConfig({ division_id: '', country_id: '', email: '' });
            setEditingEmailConfigId(null);
            setOpenEmailConfigDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error updating email config');
        }
    };

    const handleDeleteEmailConfig = async (id) => {
        if (!window.confirm('Are you sure you want to delete this email config?')) return;
        try {
            await axios.delete(`${API_URL}/setup/email-configs/${id}`, { headers });
            fetchEmailConfigs();
        } catch (err) {
            alert(err.response?.data?.message || 'Error deleting email config');
        }
    };

    const syncTicketUsers = async () => {
        try {
            await axios.post(`${API_URL}/ticket-types/sync-users`, {}, { headers });
        } catch (err) {
            console.error('Sync error:', err);
        }
    };

    const handleSaveEditSubType = async () => {
        if (!editingSubType.description.trim()) { alert('Description is required'); return; }
        try {
            await axios.put(`${API_URL}/ticket-types/sub-types/${editingSubType.id}`, {
                description: editingSubType.description,
                responsible_user_ids: editingSubType.responsible_user_ids,
                country_ids: editingSubType.country_ids
            }, { headers });
            syncTicketUsers();
            fetchData();
            setOpenEditSubTypeDialog(false);
        } catch (err) {
            alert(err.response?.data?.message || 'Error updating sub-type');
        }
    };

    if (loading) return <Loading message="Loading Setup Data..." />;

    return (
        <Box sx={{ width: '100%', overflowX: 'hidden', boxSizing: 'border-box', pb: 6, px: { xs: 1, md: 3 }, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
            <Grow in={true} timeout={500}>
                <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
                    {/* Header Section */}
                    <Paper elevation={0} sx={{
                        mb: 4, 
                        mt: 2, 
                        p: 4, 
                        borderRadius: 4, 
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
                        color: 'white',
                        boxShadow: '0 10px 30px rgba(30, 60, 114, 0.2)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        {/* Background Decorative Circles */}
                        <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
                        <Box sx={{ position: 'absolute', bottom: -100, right: 100, width: 250, height: 250, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />

                        <Box sx={{ position: 'relative', zIndex: 2, display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Avatar sx={{ 
                                width: 72, height: 72, 
                                bgcolor: 'rgba(255,255,255,0.15)', 
                                color: '#e3f2fd', 
                                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                                border: '2px solid rgba(255,255,255,0.2)',
                                backdropFilter: 'blur(4px)'
                            }}>
                                <SupervisorAccountIcon fontSize="large" sx={{ color: 'white' }} />
                            </Avatar>
                            
                            <Box>
                                <Typography sx={{ 
                                    color: 'white',
                                    fontSize: { xs: '1.5rem', md: '2rem' },
                                    fontWeight: '900',
                                    letterSpacing: 0.5,
                                    mb: 1
                                }}>
                                    System Setup
                                </Typography>
                                <Typography variant="subtitle1" sx={{ color: '#e2e8f0', fontWeight: 500 }}>
                                    Manage users, roles, countries, divisions, and ticket types
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>

                    <Card elevation={0} sx={{ borderRadius: 4, border: '1px solid #e2e8f0', bgcolor: 'white', overflow: 'hidden' }}>
                        <Tabs
                            value={value}
                            onChange={(e, v) => setValue(v)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{ 
                                borderBottom: 1, 
                                borderColor: 'divider',
                                bgcolor: '#f8fafc',
                                px: 2,
                                '& .MuiTab-root': {
                                    fontWeight: 700,
                                    py: 2.5,
                                    color: '#64748b',
                                    '&.Mui-selected': { color: '#1e3c72' }
                                }
                            }}
                        >
                    <Tab label="Users Management" />
                    <Tab label="Roles" />
                    <Tab label="Countries" />
                    <Tab label="Divisions" />
                    <Tab label="Ticket Types" />
                    <Tab label="Mobile App" />
                    <Tab label="Role Permissions" />
                    <Tab label="Email" />
                </Tabs>

                {/* Users Tab */}
                <TabPanel value={value} index={0}>
                    {/* Header Controls */}
                

                    {/* Users Management Container */}
                    <Box sx={{ borderRadius: 4, overflow: 'hidden', bgcolor: 'white', border: '1px solid #e2e8f0' }}>
                        {/* 1. Header & Controls */}
                        <Box sx={{ p: { xs: 2, md: 3 }, borderBottom: '1px solid #e2e8f0', bgcolor: 'white' }}>
                           <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} justifyContent="space-between" alignItems="center">
                                {/* Left: Search & Filter */}
                                <Stack direction="row" spacing={2} alignItems="center" sx={{ width: { xs: '100%', md: 'auto' } }}>
                                     <TextField
                                        placeholder="Search Users..."
                                        size="small"
                                        value={userSearchTerm}
                                        onChange={(e) => setUserSearchTerm(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon sx={{ color: '#94a3b8' }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{ 
                                            width: { xs: '100%', sm: 300 }, 
                                            '& .MuiOutlinedInput-root': { 
                                                borderRadius: 2,
                                                bgcolor: '#f8fafc',
                                                '& fieldset': { borderColor: '#e2e8f0' },
                                                '&:hover fieldset': { borderColor: '#cbd5e1' },
                                                '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                                            }
                                        }}
                                    />
                                    <Chip 
                                        label={`${users.filter(u => 
                                            u.username.toLowerCase().includes(userSearchTerm.toLowerCase()) || 
                                            (u.full_name && u.full_name.toLowerCase().includes(userSearchTerm.toLowerCase()))
                                        ).length} Users`}
                                        sx={{ bgcolor: '#e0e7ff', color: '#1e40af', fontWeight: 600, borderRadius: 1.5 }}
                                        size="small"
                                    />
                                </Stack>
                                
                                {/* Right: Add Button */}
                                 <Button
                                    variant="contained"
                                    startIcon={<PersonAddIcon />}
                                    onClick={() => {
                                        handleCancelEdit();
                                        setOpenUserDialog(true);
                                    }}
                                    sx={{ 
                                        bgcolor: '#1e3c72', 
                                        color: 'white', 
                                        borderRadius: 2,
                                        px: 3,
                                        fontWeight: 'bold',
                                        boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                        '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    Add New User
                                </Button>
                           </Stack>
                           
                           {/* Stats Row */}
                           <Grid container spacing={3} sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', p: 2, border: '1px solid #e2e8f0', borderRadius: 3, bgcolor: '#f8fafc' }}>
                                        <Avatar variant="rounded" sx={{ bgcolor: '#dbeafe', color: '#3b82f6', mr: 2, width: 48, height: 48, borderRadius: 2 }}>
                                            <GroupIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, letterSpacing: 0.5 }}>TOTAL USERS</Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>{users.length}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                 <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', p: 2, border: '1px solid #e2e8f0', borderRadius: 3, bgcolor: '#f8fafc' }}>
                                        <Avatar variant="rounded" sx={{ bgcolor: '#fee2e2', color: '#ef4444', mr: 2, width: 48, height: 48, borderRadius: 2 }}>
                                            <SecurityIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, letterSpacing: 0.5 }}>ADMINS</Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>{users.filter(u => u.role === 'Admin' || (u.roles && u.roles.some(r => (r.name || r) === 'Admin'))).length}</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', p: 2, border: '1px solid #e2e8f0', borderRadius: 3, bgcolor: '#f8fafc' }}>
                                        <Avatar variant="rounded" sx={{ bgcolor: '#fef3c7', color: '#f59e0b', mr: 2, width: 48, height: 48, borderRadius: 2 }}>
                                            <SupervisorAccountIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, letterSpacing: 0.5 }}>MANAGERS</Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>
                                                {users.filter(u => ['Manager', 'Country Manager', 'Division Manager'].includes(u.role)).length}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                           </Grid>
                        </Box>

                        {/* 2. Table */}
                        <TableContainer>
                            <Table size="medium">
                                <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>USER</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>ROLE</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>MANAGER</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>COUNTRIES</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>DIVISIONS</TableCell>
                                        <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>FINGERPRINT</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>ACTIONS</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {users.filter(u =>
                                        u.username.toLowerCase().includes(userSearchTerm.toLowerCase()) ||
                                        (u.full_name && u.full_name.toLowerCase().includes(userSearchTerm.toLowerCase()))
                                    ).map(u => (
                                        <TableRow key={u.id} hover sx={{ '& td': { borderBottom: '1px solid #f1f5f9' } }}>
                                            <TableCell>
                                                <Stack direction="row" alignItems="center" spacing={2}>
                                                    <Avatar {...stringAvatar(u.full_name || u.username)} sx={{ width: 40, height: 40, fontWeight: 'bold' }} />
                                                    <Box>
                                                        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1e293b' }}>
                                                            {u.full_name}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: '#64748b' }} noWrap>
                                                            {u.username}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </TableCell>
                                            <TableCell>
                                                <Box display="flex" gap={0.5} flexWrap="wrap">
                                                    {(u.roles && u.roles.length > 0 ? u.roles.map(r => r.name || r) : [u.role]).filter(r => r).map(roleName => (
                                                        <Chip
                                                            key={roleName}
                                                            label={roleName}
                                                            size="small"
                                                            sx={{ 
                                                                fontWeight: 600, 
                                                                borderRadius: 1.5,
                                                                ...(roleName === 'Admin' ? { bgcolor: '#fee2e2', color: '#b91c1c' } : roleName === 'Manager' ? { bgcolor: '#fef3c7', color: '#b45309' } : { bgcolor: '#f1f5f9', color: '#475569' }) 
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                {u.manager_id ? (
                                                     <Stack direction="row" alignItems="center" spacing={1}>
                                                        <Avatar 
                                                            sx={{ width: 24, height: 24, fontSize: '0.7rem', bgcolor: '#e2e8f0', color: '#475569', fontWeight: 'bold' }}
                                                        >
                                                            {users.find(m => m.id === u.manager_id)?.full_name?.charAt(0) || '?'}
                                                        </Avatar>
                                                        <Typography variant="body2" sx={{ color: '#334155', fontWeight: 500 }}>
                                                            {users.find(m => m.id === u.manager_id)?.full_name || 'Loading...'}
                                                        </Typography>
                                                    </Stack>
                                                ) : <Typography variant="body2" sx={{ color: '#94a3b8' }}>-</Typography>}
                                            </TableCell>
                                            <TableCell>
                                                {u.countries && u.countries.length > 0 ? (
                                                    <Box display="flex" gap={0.5} flexWrap="wrap">
                                                        {u.countries.map(c => (
                                                            <Chip key={c.id} label={c.name} size="small" sx={{ bgcolor: 'transparent', border: '1px solid #cbd5e1', color: '#475569', height: 22, fontSize: '0.7rem', fontWeight: 600, borderRadius: 1 }} />
                                                        ))}
                                                    </Box>
                                                ) : <Typography variant="body2" sx={{ color: '#94a3b8' }}>-</Typography>}
                                            </TableCell>
                                            <TableCell>
                                                {u.divisions && u.divisions.length > 0 ? (
                                                    <Box display="flex" gap={0.5} flexWrap="wrap">
                                                        {u.divisions.map(d => (
                                                            <Chip key={d.id} label={d.name} size="small" sx={{ bgcolor: '#f0fdf4', color: '#166534', height: 22, fontSize: '0.7rem', fontWeight: 600, borderRadius: 1 }} />
                                                        ))}
                                                    </Box>
                                                ) : <Typography variant="body2" sx={{ color: '#94a3b8' }}>-</Typography>}
                                            </TableCell>
                                            <TableCell>
                                                {u.has_fingerprint ? (
                                                    <Tooltip title="Registered" arrow>
                                                        <Box sx={{ display: 'inline-flex', bgcolor: '#dcfce7', p: 0.5, borderRadius: 1 }}>
                                                            <FingerprintIcon fontSize="small" sx={{ color: '#166534' }} />
                                                        </Box>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Not Registered" arrow>
                                                        <Box sx={{ display: 'inline-flex', bgcolor: '#f1f5f9', p: 0.5, borderRadius: 1 }}>
                                                            <FingerprintIcon fontSize="small" sx={{ color: '#94a3b8' }} />
                                                        </Box>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Tooltip title="Edit" arrow>
                                                    <IconButton size="small" onClick={() => handleEditUser(u)} sx={{ color: '#3b82f6', '&:hover': { bgcolor: '#eff6ff' } }}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete" arrow>
                                                    <IconButton size="small" onClick={() => handleDeleteUser(u.id)} sx={{ color: '#ef4444', '&:hover': { bgcolor: '#fef2f2' } }}>
                                                        <DeleteOutlineIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {/* User Dialog */}
                    <Dialog
                        open={openUserDialog}
                        onClose={() => setOpenUserDialog(false)}
                        maxWidth="md"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>
                                {editingUserId ? "Edit User Details" : "Create New User"}
                            </Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3 }}>
                            <Grid container spacing={3} sx={{ mt: 0.5 }}>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        freeSolo
                                        fullWidth
                                        options={adUsers}
                                        loading={adLoading}
                                        getOptionLabel={(option) => {
                                            if (typeof option === 'string') return option;
                                            return option.displayName || option.name || '';
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            handleADSearch(newInputValue);
                                        }}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <Box>
                                                    <Typography variant="body2">{option.displayName}</Typography>
                                                    <Typography variant="caption" color="textSecondary" display="block">{option.mail || option.userPrincipalName}</Typography>
                                                </Box>
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Username / Search AD"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {adLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    )
                                                }}
                                            />
                                        )}
                                        value={newUser.username}
                                        onChange={(event, newValue) => {
                                            if (typeof newValue === 'string') {
                                                setNewUser({ ...newUser, username: newValue });
                                            } else if (newValue) {
                                                const username = newValue.userPrincipalName || newValue.mail;
                                                const updates = {
                                                    ...newUser,
                                                    username: username,
                                                    full_name: newValue.displayName
                                                };

                                                // Try to match country
                                                if (newValue.country) {
                                                    const cObj = countries.find(c => c.name === newValue.country);
                                                    if (cObj) {
                                                        // Add to country_ids if not exists
                                                        if (!newUser.country_ids.includes(cObj.id)) {
                                                            updates.country_ids = [cObj.id];
                                                        }
                                                    }
                                                }
                                                setNewUser(updates);
                                            } else {
                                                setNewUser({ ...newUser, username: '' });
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label={editingUserId ? "Password (leave blank to keep)" : "Password"}
                                        type="password"
                                        value={newUser.password}
                                        onChange={e => setNewUser({ ...newUser, password: e.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField fullWidth label="Full Name" value={newUser.full_name} onChange={e => setNewUser({ ...newUser, full_name: e.target.value })} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField fullWidth label="User Description" value={newUser.user_desc || ''} onChange={e => setNewUser({ ...newUser, user_desc: e.target.value })} multiline rows={2} placeholder="Brief description about this user's role/responsibilities..." />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Roles</InputLabel>
                                        <Select
                                            multiple
                                            value={newUser.role_ids || []}
                                            label="Roles"
                                            renderValue={(selected) => selected.map(id => (roles.find(r => r.id === id) || {}).name || id).join(', ')}
                                            onChange={e => setNewUser({ ...newUser, role_ids: e.target.value })}
                                        >
                                            {roles.filter(r => r.name).map(r => <MenuItem key={r.id} value={r.id}>{r.name}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        multiple
                                        fullWidth
                                        options={countries}
                                        getOptionLabel={(option) => option.name}
                                        value={countries.filter(c => newUser.country_ids.includes(c.id))}
                                        onChange={(event, newValue) => {
                                            setNewUser({ ...newUser, country_ids: newValue.map(c => c.id) });
                                        }}
                                        renderInput={(params) => <TextField {...params} label="Countries" placeholder="Select Countries" />}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        multiple
                                        fullWidth
                                        options={divisions}
                                        getOptionLabel={(option) => option.name}
                                        value={divisions.filter(d => newUser.division_ids.includes(d.id))}
                                        onChange={(event, newValue) => {
                                            setNewUser({ ...newUser, division_ids: newValue.map(d => d.id) });
                                        }}
                                        renderInput={(params) => <TextField {...params} label="Divisions" placeholder="Select Divisions" />}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        fullWidth
                                        options={users}
                                        getOptionLabel={(option) => option.full_name || ''}
                                        value={users.find(u => u.id === newUser.manager_id) || null}
                                        onChange={(event, newValue) => {
                                            setNewUser({ ...newUser, manager_id: newValue ? newValue.id : '' });
                                        }}
                                        renderInput={(params) => <TextField {...params} label="Manager" />}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenUserDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={editingUserId ? handleUpdateUser : handleCreateUser} 
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                {editingUserId ? "Update Details" : "Create User"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>

                {/* Roles Tab */}
                <TabPanel value={value} index={1}>
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Manage Roles</Typography>
                            <Button 
                                variant="contained"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => setOpenRoleDialog(true)}
                                sx={{ 
                                    bgcolor: '#1e3c72', color: 'white', borderRadius: 2, px: 3, fontWeight: 'bold',
                                    boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                    '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add New Role
                            </Button>
                        </Box>
                        <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.02)' }}>
                            <TableContainer sx={{ bgcolor: 'white' }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '80px' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>ROLE NAME</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {roles.map(r => (
                                            <TableRow key={r.id} hover sx={{ '& td': { borderBottom: '1px solid #f1f5f9' } }}>
                                                <TableCell sx={{ fontWeight: 600, color: '#94a3b8' }}>#{r.id}</TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: '#1e293b' }}>{r.name}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                    {/* Role Dialog */}
                    <Dialog
                        open={openRoleDialog}
                        onClose={() => setOpenRoleDialog(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Add New Role</Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1 }}>
                            <TextField 
                                fullWidth 
                                label="Role Name" 
                                value={newRole} 
                                onChange={e => setNewRole(e.target.value)} 
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenRoleDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={handleCreateRole} 
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Create Role
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>

                {/* Countries Tab */}
                <TabPanel value={value} index={2}>
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Manage Countries</Typography>
                            <Button 
                                variant="contained"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => setOpenCountryDialog(true)}
                                sx={{ 
                                    bgcolor: '#1e3c72', color: 'white', borderRadius: 2, px: 3, fontWeight: 'bold',
                                    boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                    '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add New Country
                            </Button>
                        </Box>
                        <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.02)' }}>
                            <TableContainer sx={{ bgcolor: 'white' }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '80px' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>COUNTRY NAME</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>CODE</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {countries.map(c => (
                                            <TableRow key={c.id} hover sx={{ '& td': { borderBottom: '1px solid #f1f5f9' } }}>
                                                <TableCell sx={{ fontWeight: 600, color: '#94a3b8' }}>#{c.id}</TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: '#1e293b' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                        <PublicIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
                                                        {c.name}
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Chip label={c.code} size="small" sx={{ fontWeight: 'bold', borderRadius: 1.5, bgcolor: '#f1f5f9', color: '#475569' }} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                    {/* Country Dialog */}
                    <Dialog
                        open={openCountryDialog}
                        onClose={() => setOpenCountryDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Add New Country</Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <TextField 
                                    fullWidth 
                                    label="Country Name" 
                                    value={newCountry.name} 
                                    onChange={e => setNewCountry({ ...newCountry, name: e.target.value })} 
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                                <TextField 
                                    fullWidth 
                                    label="Code (1 Letter)" 
                                    value={newCountry.code} 
                                    onChange={e => setNewCountry({ ...newCountry, code: e.target.value })} 
                                    inputProps={{ maxLength: 1 }} 
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenCountryDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={handleCreateCountry} 
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Add Country
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>

                {/* Divisions Tab */}
                <TabPanel value={value} index={3}>
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Manage Divisions</Typography>
                            <Button 
                                variant="contained"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => setOpenDivisionDialog(true)}
                                sx={{ 
                                    bgcolor: '#1e3c72', color: 'white', borderRadius: 2, px: 3, fontWeight: 'bold',
                                    boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                    '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add New Division
                            </Button>
                        </Box>
                        <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.02)' }}>
                            <TableContainer sx={{ bgcolor: 'white' }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '80px' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>DIVISION NAME</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>CODE</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {divisions.map(d => (
                                            <TableRow key={d.id} hover sx={{ '& td': { borderBottom: '1px solid #f1f5f9' } }}>
                                                <TableCell sx={{ fontWeight: 600, color: '#94a3b8' }}>#{d.id}</TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: '#1e293b' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                        <BusinessIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
                                                        {d.name}
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Chip label={d.code} size="small" sx={{ fontWeight: 'bold', borderRadius: 1.5, bgcolor: '#f0fdf4', color: '#166534' }} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                    {/* Division Dialog */}
                    <Dialog
                        open={openDivisionDialog}
                        onClose={() => setOpenDivisionDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Add New Division</Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <TextField 
                                    fullWidth 
                                    label="Division Name" 
                                    value={newDivision.name} 
                                    onChange={e => setNewDivision({ ...newDivision, name: e.target.value })} 
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                                <TextField 
                                    fullWidth 
                                    label="Code (1 Letter)" 
                                    value={newDivision.code} 
                                    onChange={e => setNewDivision({ ...newDivision, code: e.target.value })} 
                                    inputProps={{ maxLength: 1 }} 
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenDivisionDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={handleCreateDivision} 
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Add Division
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>

                {/* Ticket Types Tab */}
                <TabPanel value={value} index={4}>
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Manage Ticket Types</Typography>
                            <Button 
                                variant="contained"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => setOpenTicketTypeDialog(true)}
                                sx={{ 
                                    bgcolor: '#1e3c72', color: 'white', borderRadius: 2, px: 3, fontWeight: 'bold',
                                    boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                    '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add New Ticket Type
                            </Button>
                        </Box>
                        <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.02)' }}>
                            <TableContainer sx={{ bgcolor: 'white' }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '40px' }} />
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '80px' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>TYPE NAME</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>DESCRIPTION</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>SUB-TYPES</TableCell>
                                            <TableCell align="right" sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>ACTIONS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ticketTypes.map(t => (
                                            <React.Fragment key={t.id}>
                                                <TableRow hover sx={{ '& td': { borderBottom: expandedTypeId === t.id ? 'none' : '1px solid #f1f5f9' } }}>
                                                    <TableCell sx={{ width: '40px', p: 0.5 }}>
                                                        <IconButton size="small" onClick={() => setExpandedTypeId(expandedTypeId === t.id ? null : t.id)}>
                                                            {expandedTypeId === t.id ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: 600, color: '#94a3b8' }}>#{t.id}</TableCell>
                                                    <TableCell sx={{ fontWeight: 600, color: '#1e293b' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                            <ConfirmationNumberIcon sx={{ color: '#3b82f6', fontSize: 18 }} />
                                                            {t.name}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell sx={{ color: t.description ? '#475569' : '#94a3b8', fontSize: '0.85rem', maxWidth: 320 }}>
                                                        {t.description ? t.description : <em>—</em>}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Chip label={`${(t.sub_types || []).length} sub-type(s)`} size="small" sx={{ bgcolor: '#e0f2fe', color: '#0369a1', fontWeight: 600, fontSize: '0.7rem' }} />
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Tooltip title="Edit Type" arrow>
                                                            <IconButton size="small" onClick={() => handleOpenEditTicketType(t)} sx={{ color: '#3b82f6', '&:hover': { bgcolor: '#eff6ff' }, mr: 0.5 }}>
                                                                <EditIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Add Sub-Type" arrow>
                                                            <IconButton size="small" onClick={() => handleOpenSubTypeDialog(t.id)} sx={{ color: '#3b82f6', '&:hover': { bgcolor: '#eff6ff' }, mr: 0.5 }}>
                                                                <AddCircleOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Delete Type" arrow>
                                                            <IconButton size="small" onClick={() => handleDeleteTicketType(t.id)} sx={{ color: '#ef4444', '&:hover': { bgcolor: '#fef2f2' } }}>
                                                                <DeleteOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                                {expandedTypeId === t.id && (
                                                    <TableRow>
                                                        <TableCell colSpan={6} sx={{ p: 0, bgcolor: '#f8fafc' }}>
                                                            <Box sx={{ p: 2, pl: 6 }}>
                                                                {(t.sub_types || []).length === 0 ? (
                                                                    <Typography variant="body2" sx={{ color: '#94a3b8', fontStyle: 'italic' }}>No sub-types yet. Click + to add one.</Typography>
                                                                ) : (
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem' }}>#</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem' }}>DESCRIPTION</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem' }}>RESPONSIBLE USER</TableCell>
                                                                                <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem' }}>COUNTRY</TableCell>
                                                                                <TableCell align="right" sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.7rem' }}>ACTIONS</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {(t.sub_types || []).map(s => (
                                                                                <TableRow key={s.id} sx={{ '& td': { borderBottom: '1px solid #e2e8f0' } }}>
                                                                                    <TableCell sx={{ color: '#94a3b8', fontWeight: 600, fontSize: '0.75rem' }}>
                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                                            <SubdirectoryArrowRightIcon sx={{ fontSize: 14, color: '#94a3b8' }} />
                                                                                            {s.id}
                                                                                        </Box>
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ fontWeight: 500, color: '#1e293b', fontSize: '0.85rem' }}>{s.description}</TableCell>
                                                                                    <TableCell sx={{ fontSize: '0.85rem', color: s.responsible_users?.length ? '#0369a1' : '#94a3b8' }}>
                                                                                        {s.responsible_users?.length ? s.responsible_users.map(u => u.full_name).join(', ') : '—'}
                                                                                    </TableCell>
                                                                                    <TableCell sx={{ fontSize: '0.85rem', color: s.countries?.length ? '#059669' : '#94a3b8' }}>
                                                                                        {s.countries?.length ? s.countries.map(c => c.name).join(', ') : '—'}
                                                                                    </TableCell>
                                                                                    <TableCell align="right">
                                                                                        <Tooltip title="Edit Sub-Type" arrow>
                                                                                            <IconButton size="small" onClick={() => handleOpenEditSubType(s)} sx={{ color: '#3b82f6', '&:hover': { bgcolor: '#eff6ff' }, mr: 0.5 }}>
                                                                                                <EditIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                        <Tooltip title="Delete Sub-Type" arrow>
                                                                                            <IconButton size="small" onClick={() => handleDeleteSubType(s.id)} sx={{ color: '#ef4444', '&:hover': { bgcolor: '#fef2f2' } }}>
                                                                                                <DeleteOutlineIcon fontSize="small" />
                                                                                            </IconButton>
                                                                                        </Tooltip>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                {/* Edit Type Dialog */}
                    <Dialog
                        open={openEditTypeDialog}
                        onClose={() => setOpenEditTypeDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Edit Ticket Type</Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField 
                                fullWidth 
                                label="Ticket Type Name" 
                                value={editTypeName} 
                                onChange={e => setEditTypeName(e.target.value)} 
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Description"
                                placeholder="Describe what this ticket type covers (sent to the AI ticket API)"
                                value={editTypeDesc}
                                onChange={e => setEditTypeDesc(e.target.value)}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenEditTypeDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={handleUpdateTicketType} 
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Save Changes
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Ticket Type Dialog */}
                    <Dialog
                        open={openTicketTypeDialog}
                        onClose={() => setOpenTicketTypeDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Add New Ticket Type</Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField 
                                fullWidth 
                                label="Ticket Type Name" 
                                value={newTicketType} 
                                onChange={e => setNewTicketType(e.target.value)} 
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Description"
                                placeholder="Describe what this ticket type covers (sent to the AI ticket API)"
                                value={newTicketTypeDesc}
                                onChange={e => setNewTicketTypeDesc(e.target.value)}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenTicketTypeDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={handleCreateTicketType} 
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Create Ticket Type
                            </Button>
                        </DialogActions>
                    </Dialog>
                {/* Edit Sub-Type Dialog */}
                    <Dialog
                        open={openEditSubTypeDialog}
                        onClose={() => setOpenEditSubTypeDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Edit Sub-Type</Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                                fullWidth
                                label="Description"
                                multiline
                                rows={3}
                                value={editingSubType?.description || ''}
                                onChange={e => setEditingSubType({ ...editingSubType, description: e.target.value })}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                            <Autocomplete
                                multiple
                                fullWidth
                                options={[{ id: '__all__', full_name: 'Select All' }, ...users]}
                                getOptionLabel={u => u.full_name || ''}
                                value={users.filter(u => editingSubType?.responsible_user_ids?.includes(u.id))}
                                onChange={(_, selected) => {
                                    if (selected.find(u => u.id === '__all__')) {
                                        const allIds = users.map(u => u.id);
                                        const isAllSelected = allIds.every(id => editingSubType?.responsible_user_ids?.includes(id));
                                        setEditingSubType({ ...editingSubType, responsible_user_ids: isAllSelected ? [] : allIds });
                                    } else {
                                        setEditingSubType({ ...editingSubType, responsible_user_ids: selected.map(u => u.id) });
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.id === '__all__'
                                            ? <strong>{editingSubType?.responsible_user_ids?.length === users.length ? 'Deselect All' : 'Select All'}</strong>
                                            : option.full_name}
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField {...params} label="Responsible Users" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                                )}
                                isOptionEqualToValue={(option, val) => option.id === val.id}
                            />
                            <Autocomplete
                                multiple
                                fullWidth
                                options={[{ id: '__all__', name: 'Select All' }, ...countries]}
                                getOptionLabel={c => c.name || ''}
                                value={countries.filter(c => editingSubType?.country_ids?.includes(c.id))}
                                onChange={(_, selected) => {
                                    if (selected.find(c => c.id === '__all__')) {
                                        const allIds = countries.map(c => c.id);
                                        const isAllSelected = allIds.every(id => editingSubType?.country_ids?.includes(id));
                                        setEditingSubType({ ...editingSubType, country_ids: isAllSelected ? [] : allIds });
                                    } else {
                                        setEditingSubType({ ...editingSubType, country_ids: selected.map(c => c.id) });
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.id === '__all__'
                                            ? <strong>{editingSubType?.country_ids?.length === countries.length ? 'Deselect All' : 'Select All'}</strong>
                                            : option.name}
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField {...params} label="Countries" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                                )}
                                isOptionEqualToValue={(option, val) => option.id === val.id}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenEditSubTypeDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button
                                onClick={handleSaveEditSubType}
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Save Changes
                            </Button>
                        </DialogActions>
                    </Dialog>

                {/* Add Sub-Type Dialog */}
                    <Dialog
                        open={openSubTypeDialog}
                        onClose={() => setOpenSubTypeDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Add Sub-Type</Typography>
                            <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
                                {ticketTypes.find(t => t.id === subTypeParentId)?.name}
                            </Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField
                                fullWidth
                                label="Description"
                                multiline
                                rows={3}
                                value={newSubType.description}
                                onChange={e => setNewSubType({ ...newSubType, description: e.target.value })}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                            <Autocomplete
                                multiple
                                fullWidth
                                options={[{ id: '__all__', full_name: 'Select All' }, ...users]}
                                getOptionLabel={u => u.full_name || ''}
                                value={users.filter(u => newSubType.responsible_user_ids.includes(u.id))}
                                onChange={(_, selected) => {
                                    if (selected.find(u => u.id === '__all__')) {
                                        const allIds = users.map(u => u.id);
                                        const isAllSelected = allIds.every(id => newSubType.responsible_user_ids.includes(id));
                                        setNewSubType({ ...newSubType, responsible_user_ids: isAllSelected ? [] : allIds });
                                    } else {
                                        setNewSubType({ ...newSubType, responsible_user_ids: selected.map(u => u.id) });
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.id === '__all__'
                                            ? <strong>{newSubType.responsible_user_ids.length === users.length ? 'Deselect All' : 'Select All'}</strong>
                                            : option.full_name}
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField {...params} label="Responsible Users" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                                )}
                                isOptionEqualToValue={(option, val) => option.id === val.id}
                            />
                            <Autocomplete
                                multiple
                                fullWidth
                                options={[{ id: '__all__', name: 'Select All' }, ...countries]}
                                getOptionLabel={c => c.name || ''}
                                value={countries.filter(c => newSubType.country_ids.includes(c.id))}
                                onChange={(_, selected) => {
                                    if (selected.find(c => c.id === '__all__')) {
                                        const allIds = countries.map(c => c.id);
                                        const isAllSelected = allIds.every(id => newSubType.country_ids.includes(id));
                                        setNewSubType({ ...newSubType, country_ids: isAllSelected ? [] : allIds });
                                    } else {
                                        setNewSubType({ ...newSubType, country_ids: selected.map(c => c.id) });
                                    }
                                }}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.id === '__all__'
                                            ? <strong>{newSubType.country_ids.length === countries.length ? 'Deselect All' : 'Select All'}</strong>
                                            : option.name}
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField {...params} label="Countries" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                                )}
                                isOptionEqualToValue={(option, val) => option.id === val.id}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenSubTypeDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button
                                onClick={handleCreateSubType}
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                Add Sub-Type
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>

                {/* Mobile App Tab */}
                <TabPanel value={value} index={5}>
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Manage Mobile Apps</Typography>
                            <Button 
                                variant="contained"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => {
                                    setEditingMobileAppId(null);
                                    setNewMobileApp({ app_type: '', link: '', version: '' });
                                    setOpenMobileAppDialog(true);
                                }}
                                sx={{ 
                                    bgcolor: '#1e3c72', color: 'white', borderRadius: 2, px: 3, fontWeight: 'bold',
                                    boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                    '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add Mobile App
                            </Button>
                        </Box>
                        <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.02)' }}>
                            <TableContainer sx={{ bgcolor: 'white' }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '80px' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>TYPE</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>VERSION</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>LINK</TableCell>
                                            <TableCell align="right" sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>ACTIONS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {mobileApps.map(a => (
                                            <TableRow key={a.id} hover sx={{ '& td': { borderBottom: '1px solid #f1f5f9' } }}>
                                                <TableCell sx={{ fontWeight: 600, color: '#94a3b8' }}>#{a.id}</TableCell>
                                                <TableCell>
                                                    <Chip label={a.app_type} size="small" sx={{ fontWeight: 600, borderRadius: 1.5, bgcolor: '#e0f2fe', color: '#0369a1' }} />
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: '#1e293b' }}>{a.version || '—'}</TableCell>
                                                <TableCell sx={{ maxWidth: 300 }}>
                                                    <Typography variant="body2" sx={{ color: a.link ? '#2563eb' : '#94a3b8', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {a.link || 'No link'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Tooltip title="Edit" arrow>
                                                        <IconButton size="small" onClick={() => {
                                                            setEditingMobileAppId(a.id);
                                                            setNewMobileApp({ app_type: a.app_type, link: a.link || '', version: a.version || '' });
                                                            setOpenMobileAppDialog(true);
                                                        }} sx={{ color: '#3b82f6', '&:hover': { bgcolor: '#eff6ff' }, mr: 0.5 }}>
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" arrow>
                                                        <IconButton size="small" onClick={() => {
                                                            if (!window.confirm('Delete this mobile app?')) return;
                                                            axios.delete(`${API_URL}/setup/mobile-apps/${a.id}`, { headers }).then(fetchMobileApps);
                                                        }} sx={{ color: '#ef4444', '&:hover': { bgcolor: '#fef2f2' } }}>
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {mobileApps.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" sx={{ py: 6, color: '#94a3b8', fontWeight: 500 }}>
                                                    No mobile apps configured yet.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                    {/* Mobile App Dialog */}
                    <Dialog
                        open={openMobileAppDialog}
                        onClose={() => setOpenMobileAppDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>
                                {editingMobileAppId ? 'Edit Mobile App' : 'Add Mobile App'}
                            </Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <FormControl fullWidth>
                                <InputLabel>App Type</InputLabel>
                                <Select 
                                    value={newMobileApp.app_type} 
                                    label="App Type" 
                                    onChange={e => setNewMobileApp({ ...newMobileApp, app_type: e.target.value })}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                >
                                    <MenuItem value="iOS">iOS</MenuItem>
                                    <MenuItem value="Android">Android</MenuItem>
                                    <MenuItem value="Both">Both</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField 
                                fullWidth 
                                label="Version" 
                                value={newMobileApp.version} 
                                onChange={e => setNewMobileApp({ ...newMobileApp, version: e.target.value })} 
                                placeholder="e.g. 1.0.0"
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                            <TextField 
                                fullWidth 
                                label="Link (URL)" 
                                value={newMobileApp.link} 
                                onChange={e => setNewMobileApp({ ...newMobileApp, link: e.target.value })} 
                                placeholder="e.g. https://apps.apple.com/..."
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenMobileAppDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={async () => {
                                    try {
                                        if (editingMobileAppId) {
                                            await axios.put(`${API_URL}/setup/mobile-apps/${editingMobileAppId}`, newMobileApp, { headers });
                                        } else {
                                            await axios.post(`${API_URL}/setup/mobile-apps`, newMobileApp, { headers });
                                        }
                                        fetchMobileApps();
                                        setOpenMobileAppDialog(false);
                                        setNewMobileApp({ app_type: '', link: '', version: '' });
                                        setEditingMobileAppId(null);
                                    } catch (err) {
                                        alert(err.response?.data?.message || 'Error saving mobile app');
                                    }
                                }}
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                {editingMobileAppId ? 'Update' : 'Add'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>

                {/* Role Permissions Tab */}
                <TabPanel value={value} index={6}>
                    <RolePermissions />
                </TabPanel>

                {/* Email Tab */}
                <TabPanel value={value} index={7}>
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Manage Email Configurations</Typography>
                            <Button 
                                variant="contained"
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => {
                                    setEditingEmailConfigId(null);
                                    setNewEmailConfig({ division_id: '', country_id: '', email: '' });
                                    setOpenEmailConfigDialog(true);
                                }}
                                sx={{ 
                                    bgcolor: '#1e3c72', color: 'white', borderRadius: 2, px: 3, fontWeight: 'bold',
                                    boxShadow: '0 4px 14px rgba(30, 60, 114, 0.2)',
                                    '&:hover': { bgcolor: '#152b53', transform: 'translateY(-1px)' },
                                    transition: 'all 0.2s'
                                }}
                            >
                                Add Email Config
                            </Button>
                        </Box>
                        <Box sx={{ border: '1px solid #e2e8f0', borderRadius: 3, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.02)' }}>
                            <TableContainer sx={{ bgcolor: 'white' }}>
                                <Table size="medium">
                                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem', width: '80px' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>DIVISION</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>COUNTRY</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>EMAIL</TableCell>
                                            <TableCell align="right" sx={{ fontWeight: 700, color: '#64748b', fontSize: '0.75rem' }}>ACTIONS</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {emailConfigs.map(c => (
                                            <TableRow key={c.id} hover sx={{ '& td': { borderBottom: '1px solid #f1f5f9' } }}>
                                                <TableCell sx={{ fontWeight: 600, color: '#94a3b8' }}>#{c.id}</TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: '#1e293b' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                        <BusinessIcon sx={{ color: '#94a3b8', fontSize: 18 }} />
                                                        {c.division?.name || '—'}
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <PublicIcon sx={{ color: '#94a3b8', fontSize: 16 }} />
                                                        <Chip label={c.country?.name || '—'} size="small" sx={{ fontWeight: 600, borderRadius: 1.5, bgcolor: '#f1f5f9', color: '#475569' }} />
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <EmailIcon sx={{ color: '#3b82f6', fontSize: 18 }} />
                                                        <Typography variant="body2" sx={{ color: '#2563eb', fontWeight: 500 }}>{c.email}</Typography>
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Tooltip title="Edit" arrow>
                                                        <IconButton size="small" onClick={() => {
                                                            setEditingEmailConfigId(c.id);
                                                            setNewEmailConfig({ division_id: c.division_id, country_id: c.country_id, email: c.email });
                                                            setOpenEmailConfigDialog(true);
                                                        }} sx={{ color: '#3b82f6', '&:hover': { bgcolor: '#eff6ff' }, mr: 0.5 }}>
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" arrow>
                                                        <IconButton size="small" onClick={() => handleDeleteEmailConfig(c.id)} sx={{ color: '#ef4444', '&:hover': { bgcolor: '#fef2f2' } }}>
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {emailConfigs.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" sx={{ py: 6, color: '#94a3b8', fontWeight: 500 }}>
                                                    No email configurations yet.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>

                    {/* Email Config Dialog */}
                    <Dialog
                        open={openEmailConfigDialog}
                        onClose={() => setOpenEmailConfigDialog(false)}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ elevation: 0, sx: { borderRadius: 3, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
                    >
                        <DialogTitle sx={{ pb: 2, pt: 3, px: 3, borderBottom: '1px solid #f1f5f9' }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>
                                {editingEmailConfigId ? 'Edit Email Config' : 'Add Email Config'}
                            </Typography>
                        </DialogTitle>
                        <DialogContent sx={{ p: 3, mt: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                            <FormControl fullWidth>
                                <InputLabel>Division</InputLabel>
                                <Select 
                                    value={newEmailConfig.division_id} 
                                    label="Division" 
                                    onChange={e => setNewEmailConfig({ ...newEmailConfig, division_id: e.target.value })}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                >
                                    {divisions.map(d => (
                                        <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel>Country</InputLabel>
                                <Select 
                                    value={newEmailConfig.country_id} 
                                    label="Country" 
                                    onChange={e => setNewEmailConfig({ ...newEmailConfig, country_id: e.target.value })}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                >
                                    {countries.map(c => (
                                        <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField 
                                fullWidth 
                                label="Email Address" 
                                type="email"
                                value={newEmailConfig.email} 
                                onChange={e => setNewEmailConfig({ ...newEmailConfig, email: e.target.value })} 
                                placeholder="e.g. admin@acts-int.net"
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                        </DialogContent>
                        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #f1f5f9' }}>
                            <Button onClick={() => setOpenEmailConfigDialog(false)} sx={{ color: '#64748b', fontWeight: 600 }}>Cancel</Button>
                            <Button 
                                onClick={editingEmailConfigId ? handleUpdateEmailConfig : handleCreateEmailConfig}
                                variant="contained"
                                sx={{ bgcolor: '#1e3c72', fontWeight: 'bold', px: 3, borderRadius: 2, '&:hover': { bgcolor: '#152b53' } }}
                            >
                                {editingEmailConfigId ? 'Update' : 'Add'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </TabPanel>
            </Card>
                </Box>
            </Grow>
        </Box>
    );
}

export default Setup;
